import Autocomplete from "@mui/material/Autocomplete";

function RoleOptions({ value, onChange, hasJugador, hasTecnico }) {
    const jugadorDisponible = Boolean(hasJugador);
    const tecnicoDisponible = Boolean(hasTecnico);

    const options = [];
    if (jugadorDisponible) {
        options.push({ value: "jugador", label: "Jugador" });
    }
    if (tecnicoDisponible) {
        options.push({ value: "tecnico", label: "Técnico" });
    }

    const fallbackOptions = [{ value: "jugador", label: "Jugador" }, { value: "tecnico", label: "Técnico" }];
    const visibleOptions = options.length ? options : fallbackOptions;

    return (
        <div className="relative">
            <select
                value={value}
                onChange={(event) => onChange?.(event.target.value)}
                className="w-full h-11 appearance-none rounded-xl border border-white/10 bg-[#102216]/70 px-3 pr-10 text-sm text-slate-100"
            >
                {visibleOptions.map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                ))}
            </select>
            <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-slate-400">
                <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4" aria-hidden="true">
                    <path d="m5 7 5 5 5-5" />
                </svg>
            </span>
        </div>
    );
}

function ScopeOptions({ value, onChange, options = [] }) {
    return (
        <div className="relative">
            <select
                value={value}
                onChange={(event) => onChange?.(event.target.value)}
                className="w-full h-11 appearance-none rounded-xl border border-white/10 bg-[#102216]/70 px-3 pr-10 text-sm text-slate-100"
            >
                {options.map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                ))}
            </select>
            <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-slate-400">
                <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4" aria-hidden="true">
                    <path d="m5 7 5 5 5-5" />
                </svg>
            </span>
        </div>
    );
}

function SelectorCard({
    title,
    value,
    onChange,
    options,
    role,
    onRoleChange,
    hasJugador,
    hasTecnico,
    scope,
    onScopeChange,
    scopeOptions,
}) {
    return (
        <div className="rounded-2xl border border-white/10 bg-[#102216]/70 p-2.5 sm:p-4 md:p-5 space-y-2.5 sm:space-y-3">
            <p className="text-[11px] sm:text-xs font-bold uppercase tracking-[0.18em] text-slate-400">{title}</p>

            <Autocomplete
                value={value || null}
                options={options}
                onChange={(event, newValue) => onChange?.(newValue || "")}
                renderInput={(params) => (
                    <div ref={params.InputProps.ref} className="flex items-center rounded-lg border border-white/10 bg-white/5 backdrop-blur-xl px-3 py-2 focus-within:border-green-500/60 transition-colors">
                        <span className="text-slate-400 mr-2">
                            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                                <circle cx="11" cy="11" r="8" />
                                <path d="m21 21-4.3-4.3" />
                            </svg>
                        </span>
                        <input
                            type="text"
                            {...params.inputProps}
                            placeholder="Buscar jugador/técnico"
                            className="w-full bg-transparent text-slate-100 placeholder:text-slate-500 focus:outline-none"
                        />
                    </div>
                )}
            />

            <div className="grid grid-cols-2 gap-2 sm:gap-3">
                <RoleOptions value={role} onChange={onRoleChange} hasJugador={hasJugador} hasTecnico={hasTecnico} />
                <ScopeOptions value={scope} onChange={onScopeChange} options={scopeOptions} />
            </div>
        </div>
    );
}

export default function CompararFilters({
    options,
    leftName,
    setLeftName,
    rightName,
    setRightName,
    leftRole,
    setLeftRole,
    rightRole,
    setRightRole,
    leftScope,
    setLeftScope,
    rightScope,
    setRightScope,
    leftScopeOptions,
    rightScopeOptions,
    leftProfile,
    rightProfile,
}) {
    return (
        <section className="mb-6 sm:mb-10">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-2.5 sm:gap-4">
                <SelectorCard
                    title="Perfil 1"
                    value={leftName}
                    onChange={setLeftName}
                    options={options}
                    role={leftRole}
                    onRoleChange={setLeftRole}
                    hasJugador={leftProfile?.hasJugadorProfile}
                    hasTecnico={leftProfile?.hasTecnicoProfile}
                    scope={leftScope}
                    onScopeChange={setLeftScope}
                    scopeOptions={leftScopeOptions}
                />

                <SelectorCard
                    title="Perfil 2"
                    value={rightName}
                    onChange={setRightName}
                    options={options}
                    role={rightRole}
                    onRoleChange={setRightRole}
                    hasJugador={rightProfile?.hasJugadorProfile}
                    hasTecnico={rightProfile?.hasTecnicoProfile}
                    scope={rightScope}
                    onScopeChange={setRightScope}
                    scopeOptions={rightScopeOptions}
                />
            </div>
        </section>
    );
}